/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.14.0
 * @since 1.0.0
 */
import {
    ErrorPageDescriptionStyled,
    ErrorPageImgContainerStyled,
    ErrorPageImgStyled,
    ErrorPageStyled,
    ErrorPageTitleStyled,
} from './styled/ErrorPageStyled';

export interface IErrorPageProps {
    text: string;
    title: string;
    src: string;
}

const ErrorPage = (props: IErrorPageProps) => {
    return (
        <ErrorPageStyled data-name="error-page">
            <ErrorPageImgContainerStyled>
                <ErrorPageImgStyled src={props.src}/>
            </ErrorPageImgContainerStyled>
            <ErrorPageTitleStyled>
                {props.title}
            </ErrorPageTitleStyled>
            <ErrorPageDescriptionStyled>
                {props.text}
            </ErrorPageDescriptionStyled>
        </ErrorPageStyled>
    );
};

export default ErrorPage;
